import { render } from "./ConfirmSignup.vue?vue&type=template&id=ad42304e&scoped=true"
const script = {}

import "./ConfirmSignup.vue?vue&type=style&index=0&id=ad42304e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad42304e"]])

export default __exports__